module.exports = __webpack_public_path__ + "img/6.785e8358.png";